export default __webpack_public_path__ + "static/min-duration-a940c1fce769536bc1cf2f3c6735ab37.png";